<template>
  <TemplateView>
    <div class="container">
    <TemplatePageGrid
        :items="workClientProjectsPeriodReportGrid && workClientProjectsPeriodReportGrid.data || []"
        :page-data="pageData"
        :loading="loadingAnimation"
    >
      <div class="d-flex flex-wrap align-center gap-10" slot="buttons">
      <template v-if="userType !== 'subscriber'">
        <StatisticProjectReportsModal/>
        <!--          <BaseButton-->
        <!--            default_icon="button-add_report"-->
        <!--            icon_only-->
        <!--            @click.native="$router.push({ name: 'timeControlShowReportsFree' })"-->
        <!--          />-->
      </template>

        <div class="d-flex flex-column">
          <label class="primary--text f14 fw500 temp">
            {{ localStorage.translations.pages['statistic_project'].tables.period }}
          </label>
          <div class="d-flex flex-wrap">
            <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    hide-details
                    v-model="dateRangeText"
                    filled
                    height="30"
                    v-bind="attrs"
                    readonly
                    clearable
                    prepend-inner-icon="today"
                    placeholder="—"
                    v-on="on"
                    class="temp"
                    @click:clear="filter.period = [], downloadPageData(true)"
                />
              </template>
              <v-date-picker
                  :locale="$cookies.get('languageSelect').key"
                  v-model="filter.period"
                  range
                  no-title
                  show-week
                  first-day-of-week="1"
                  :max="new Date().toISOString().slice(0, 10)"
              >
                <BaseButton
                    class="ml-auto mr-0"
                    :text="localStorage.translations.pages.common.buttons.confirm"
                    :disabled="filter.period && filter.period.length < 1"
                    @click=";(menu = false), downloadPageData(true)"
                />
              </v-date-picker>
            </v-menu>
          </div>
        </div>
      </div>
      <StatisticProjectReportsTable
        v-if="workClientProjectsPeriodReportGrid"
          :items="workClientProjectsPeriodReportGrid.data"
          :function_dataList="downloadPageData"
      />
    </TemplatePageGrid>
    </div>
  </TemplateView>
</template>

<script>
import TemplateView from 'components/templates/TemplateView'
import TemplatePageGrid from 'components/templates/TemplatePageGrid'
import StatisticProjectReportsTable from 'components/timeControl/reports/StatisticProjectReportsTable'
import StatisticProjectReportsModal from 'components/timeControl/reports/StatisticProjectReportsModal'
import {mapActions, mapGetters, mapMutations} from 'vuex'

export default {
  name: 'timeControlShowReports',
  components: {
    TemplatePageGrid,
    TemplateView,
    StatisticProjectReportsTable,
    StatisticProjectReportsModal,
  },
  data: () => ({
    loading: false,
    menu: false,
    filter: {
      period: [],
      project: [],
    },
  }),
  computed: {
    ...mapGetters('user', ['userType']),
    ...mapGetters('workClientProjectsPeriodReport', [
      'workClientProjectsPeriodReportGrid',
      'pageData',
    ]),
    ...mapGetters('workClientProject', ['workClientProjectAllReports']),
    ...mapGetters(['loadingAnimation']),
    translation() {
      return this.localStorage.translations.pages.projects['reports_table']
    },
    dateRangeText() {
      let result = []
      if (this.filter.period && this.filter.period.length > 0) {
        let dates = [...this.filter.period]
        if (dates[0]) {
          dates[0] = this.$formatDate(dates[0])
        }
        if (dates[1]) {
          dates[1] = this.$formatDate(dates[1])
        }
        if (dates[0] && dates[1] && dates[0] > dates[1]) {
          dates = [dates[1], dates[0]]
        }
        result = dates.join(' - ')
      } else {
        result = null
      }
      return result
    },
  },
  watch: {
    '$route.query'() {
      this.downloadPageData()
      // this.onDownloadData()
    },
  },
  created() {
    this.firstPeriodDateData()
    this.onWorkClientProjectStatistic(this.$route.params.id)
    this.downloadPageData()
    // this.onDownloadData()
  },
  methods: {
    ...mapActions('workClientProjectsPeriodReport', ['onWorkClientProjectsPeriodReportGrid']),
    ...mapActions('workClientProject', ['onWorkClientProjectStatistic', 'onWorkClientProjectAllReports']),
    ...mapMutations(['setLoadingAnimation']),
    firstPeriodDateData() {
      let currentDate = new Date();
      let dd = currentDate.getDate()
      let mm = currentDate.getMonth() + 1
      let yyyy = currentDate.getFullYear()
      this.filter.period = []
      this.filter.period.push(String(yyyy + '-' + String(mm == 1 ? 12 : mm - 1).padStart(2, '0') + '-' + String(dd).padStart(2, '0')))
      this.filter.period.push(String(yyyy + '-' + String(mm).padStart(2, '0') + '-' + String(dd).padStart(2, '0')))
      this.lastMonthPeriod = this.filter.period
      this.currentMonth = mm
    },
    async downloadPageData(resetPeriod) {
      let local = localStorage.getItem('periodProjectStatisticReport')
        ? JSON.parse(localStorage.getItem('periodProjectStatisticReport')) : {}
      let temp_local = local[this.$route.params.id] ? local[this.$route.params.id].period : this.filter.period
      let query = Object.assign({period: temp_local, month: this.currentMonth})
      if (!!this.$route.params.id) {
        if (!local[this.$route.params.id]) local[this.$route.params.id] = {}
        local[this.$route.params.id] = query
        if (resetPeriod || (local && local.month < this.currentMonth)) {
          local[this.$route.params.id].period = this.filter.period
        }
      }
      this.filter.period = local[this.$route.params.id].period
      this.loading = true
      let data = {
        period: this.filter.period,
        limit: this.$route.query.limit,
        page: this.$route.query.page,
        project_id: this.$route.params.id,
      }
      if (this.$route.query.sort_param && this.$route.query.sort_value) {
        data.sort = {
          param: this.$route.query.sort_param,
          value: this.$route.query.sort_value,
        }
      }
      if (this.filter.period && this.filter.period.length) {
        if (this.filter.period[1] && this.filter.period[0] > this.filter.period[1])
          data.period = [this.filter.period[1], this.filter.period[0]]
        if (!this.filter.period[1]) {
          this.filter.period[1] = this.filter.period[0]
          data.period = [data.period[0], data.period[1]]
        }
      } else {
        data.period = []
      }
      await this.onWorkClientProjectsPeriodReportGrid(data).then((res) => {
        this.setLoadingAnimation(false)
        localStorage.setItem('periodProjectStatisticReport', JSON.stringify(local))
    })
          .catch(() => (this.loading = false))
    },

    // async onDownloadData(resetPeriod) {
    //   let local = localStorage.getItem('periodProjectStatisticReport')
    //       ? JSON.parse(localStorage.getItem('periodProjectStatisticReport')) : {}
    //   let temp_local = local[this.$route.params.id] ? local[this.$route.params.id].period : this.filter.period
    //   let query = Object.assign({period: temp_local, month: this.currentMonth})
    //   if (!!this.$route.params.id) {
    //     if (!local[this.$route.params.id]) local[this.$route.params.id] = {}
    //     local[this.$route.params.id] = query
    //     if (resetPeriod || (local && local.month < this.currentMonth)) {
    //       local[this.$route.params.id].period = this.filter.period
    //     }
    //   }
    //   this.filter.period = local[this.$route.params.id].period
    //   this.setLoadingAnimation(true)
    //   let data = {
    //     filter: {
    //       period: this.filter.period,
    //       project: [this.$route.params.id],
    //     },
    //     limit: this.$route.query.limit,
    //     page: this.$route.query.page,
    //   }
    //   if (this.filter.period && this.filter.period.length) {
    //     if (this.filter.period[1] && this.filter.period[0] > this.filter.period[1])
    //       data.filter.period = [this.filter.period[1], this.filter.period[0]]
    //     if (!this.filter.period[1]) {
    //       this.filter.period[1] = this.filter.period[0]
    //       data.filter.period = [data.filter.period[0], data.filter.period[1]]
    //     }
    //   } else {
    //     data.filter.period = []
    //   }
    //   await this.onWorkClientProjectAllReports(data).then((res) => {
    //     this.setLoadingAnimation(false)
    //     localStorage.setItem('periodProjectStatisticReport', JSON.stringify(local))
    //   })
    // },
  },
}
</script>

<style lang="scss" scoped>
.inner {
  margin-left: 15px;
  position: relative;

  &-border {
    position: absolute;
    top: -100%;
    left: -15px;
    width: 10px;
    height: 140%;
    border-bottom: 1px dotted var(--v-primary-base);
    border-left: 1px dotted var(--v-primary-base);

    &-first {
      position: absolute;
      top: -30%;
      left: -15px;
      width: 10px;
      height: 80%;
      border-bottom: 1px dotted var(--v-primary-base);
      border-left: 1px dotted var(--v-primary-base);
    }

    &-mobile {
      position: absolute;
      top: -60%;
      left: -10px;
      width: 10px;
      height: 120%;
      border-bottom: 1px dotted var(--v-primary-base);
      border-left: 1px dotted var(--v-primary-base);

      &-first {
        position: absolute;
        top: -15%;
        left: -10px;
        width: 10px;
        height: 75%;
        border-bottom: 1px dotted var(--v-primary-base);
        border-left: 1px dotted var(--v-primary-base);
      }
    }
  }
}

.filterList {
  border: 1px solid transparent;

  &-new {
    font-weight: 700 !important;
  }

  &-mobile {
    border: 1px solid var(--v-secondary-lighten4);
  }
}

.totalLine {
  background-color: var(--v-secondary-lighten4);

  &-mobile {
    border: 1px solid var(--v-secondary-lighten4);
  }
}

label.temp {
  display: block;
  margin-bottom: 5px;
  line-height: 16px !important;
}

:deep() .v-input.v-text-field .v-input__slot:not(.v-textarea) {
  min-height: 30px !important;
  border-radius: 10px !important;
}

:deep() .v-sheet.v-card {
  border-radius: 10px !important;
}

.temp {
  :deep() .v-input__slot {
    width: max-content !important;
  }
}
</style>
